exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "iframe.calendar{margin:2em 0 0;width:100%}\n", ""]);

